import React, { useState } from "react";
import { useDispatch } from "react-redux";
import StepperButtons from "../StepperButtons";
import { Formik, Form, Field } from "formik";
import {
    Stack,
    Typography,
    MenuItem,
    Tooltip,
    InputAdornment,
    Box,
    TextField,
    Grid,
    Paper,
    Button,
} from "@mui/material";
import AttachmentTable from "../../Attachments/AttachmentTable";
import { additionalInfo as text } from "../../../context/preparationPhase";
import { patchProject } from "../ProjectActions";

const fields = [
    {
        name: "extendedDescription",
        label: "Uitgebreide projectbeschrijving",
        helperText: "",
    },
    {
        name: "sectorSustainabilityPolicy",
        label: "Beleid en wet- en regelgeving duurzaamheid",
        helperText: text.explanationSectorSustainabilityPolicy,
    },
    {
        name: "stakeholderSustainabilityPolicy",
        label: "Duurzaamheidsbeleid van relevante stakeholders",
        helperText: text.explanationStakeholderSustainabilityPolicy,
    },
    {
        name: "sustainabilityApproach",
        label: "Duurzaamheidsaanpak",
        helperText: text.explanationSustainabilityApproach,
    },
];

export default function AdditionalProjectInfo({ payload }) {
    const dispatch = useDispatch();
    const { project, editable } = payload;

    const LargeField = ({ name, label, values, setValues, helperText }) => {
        return (
            <Field
                component={TextField}
                name={name}
                label={label}
                type="text"
                placeholder={label}
                value={values[name]}
                onChange={(e) =>
                    setValues({
                        ...values,
                        [name]: e.target.value,
                    })
                }
                disabled={!editable}
                multiline
                minRows={3}
                maxRows={8}
                sx={{ minWidth: 150 }}
                helperText={helperText}
                fullWidth
            />
        );
    };

    const DedicatedAttachmentTable = ({ purpose }) => {
        return (
            <AttachmentTable
                parentType="project"
                parentIds={{ project: project.id }}
                parentObj={project}
                defaultExpanded={false}
                showHeader={true}
                purpose={purpose}
            />
        );
    };

    const initValues = {};
    for (const key of fields) {
        initValues[key.name] = project[key.name];
    }

    const handleSubmit = (values) => {
        patchProject({ ...values, id: project.id }, dispatch);
    };

    return (
        <Box>
            <Typography paragraph>{text.description}</Typography>
            <Formik
                enableReinitialize
                initialValues={initValues}
                onSubmit={handleSubmit}
            >
                {({ isValid, values, setValues, handleSubmit, dirty }) => (
                    <Form>
                        <Grid container spacing={4}>
                            {fields.map((field) => (
                                <>
                                    <Grid item xs={6}>
                                        <LargeField
                                            name={field.name}
                                            label={field.label}
                                            helperText={field.helperText}
                                            values={values}
                                            setValues={setValues}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box display="flex" alignItems="center">
                                            <DedicatedAttachmentTable
                                                purpose={field.name}
                                            />
                                        </Box>
                                    </Grid>
                                </>
                            ))}
                        </Grid>
                        {!isValid && (
                            <Typography color="error">
                                Formulier is niet correct ingevuld
                            </Typography>
                        )}
                        <Button
                            sx={{ mt: 2 }}
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!isValid || !editable || !dirty}
                        >
                            Opslaan
                        </Button>
                        <StepperButtons
                            payload={payload}
                            updateStatus={false}
                            saveAction={dirty ? handleSubmit : undefined}
                        />
                    </Form>
                )}
            </Formik>
        </Box>
    );
}
